export default __webpack_public_path__ + "static/media/Madison 9781408312865.51165b86.jpg";